import { Form } from 'antd'
import { FormInstance } from 'antd/lib/form/Form'
import { t } from 'i18next'
import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import SelectStore from '../../../../components/SelectStore'
import { workspaceTypes } from '../../../../constants/constants'
import { DataStore } from '../../../../store/reducers/dataStoreReducer'
  
interface CreateWorkspaceModalDataStoreStepProps {
  form: FormInstance
}

const CreateWorkspaceModalOutputStep = memo(
  ({ form }: CreateWorkspaceModalDataStoreStepProps) => {
    const selectedDataStore = form.getFieldValue('selectedDataStore')
    const currentUser = useSelector((state: any) => state.user.currentUser)

    const handleOnChange = (value: DataStore | undefined) => {
      form.setFieldValue('selectedDataStore', value)

      // backend needs an array of ids.
      form.setFieldValue('selectedDataStores', value ? [value.id] : [])
      // reset participants to empty array
      form.setFieldValue('participants', currentUser ? [currentUser.id] : [])
    }

    const workspaceType = useMemo(() => {
      return form.getFieldValue('workspaceTypeCode')
    }, [form])

    return (
      <div>
        <Form.Item
          name="selectedDataStore"
          label={t('createWorkspaceModal.storeStep.subHeader')}
          extra={t('createWorkspaceModal.storeStep.infoBox')}
          rules={[
            {
              required: workspaceType === workspaceTypes.DEL,
              message: t('errorMessage.isRequired'),
            },
          ]}
        >
          <SelectStore
            onChange={handleOnChange}
            value={selectedDataStore}
            placeholder={t('createWorkspaceModal.storeStep.placeholder') || ''}
          />
        </Form.Item>
      </div>
    )
  }
)

export default CreateWorkspaceModalOutputStep
